import { List, ListIcon, ListItem, Spacer, Text } from "@chakra-ui/react";
import { Check, Circle, CircleSolid } from "@airhelp/icons";

interface FunnelProgressBarProps {
  segments: readonly string[];
  activeSegment: number;
  segmentTitle: (step: string) => string;
}
export function FunnelProgressBar({
  segments,
  activeSegment,
  segmentTitle,
}: FunnelProgressBarProps) {
  return (
    <List mt={16}>
      {segments.map((segment, idx) => {
        return (
          <ProgressBarItem
            key={idx}
            title={segmentTitle(segment)}
            isActive={idx === activeSegment}
            isVisited={idx < activeSegment}
            isInactive={idx > activeSegment}
          />
        );
      })}
    </List>
  );
}

function ProgressBarItem({
  title,
  isVisited,
  isActive,
  isInactive,
}: {
  title: string;
  isVisited?: boolean;
  isActive?: boolean;
  isInactive?: boolean;
}) {
  if (isVisited) {
    return (
      <>
        <ListItem
          px={9}
          py={1}
          borderLeft={"2px"}
          lineHeight={"24px"}
          borderColor={"greyscale.400"}
        >
          <ListIcon as={Check} boxSize={6} mr={2} color={"var(--font-color-primary)"} />
          <Text
            as={"span"}
            fontSize={"md"}
            color={"var(--font-color-primary)"}
            verticalAlign={"text-bottom"}
          >
            {title}
          </Text>
        </ListItem>

        <ProgressBarSpacer />
      </>
    );
  }

  if (isActive) {
    return (
      <>
        <ListItem
          px={9}
          py={1}
          borderLeft={"2px"}
          lineHeight={"24px"}
          borderColor={"var(--font-color-primary)"}
        >
          <ListIcon as={CircleSolid} boxSize={5} mr={3} color={"var(--font-color-primary)"} />
          <Text fontSize={"md"} as={"span"} color={"var(--font-color-primary)"} fontWeight={500}>
            {title}
          </Text>
        </ListItem>

        <ProgressBarSpacer />
      </>
    );
  }

  if (isInactive) {
    return (
      <>
        <ListItem
          px={9}
          py={1}
          borderLeft={"2px"}
          lineHeight={"24px"}
          borderColor={"greyscale.400"}
        >
          <ListIcon as={Circle} boxSize={5} mr={3} color={"greyscale.500"} />
          <Text fontSize={"md"} as={"span"} color={"greyscale.500"}>
            {title}
          </Text>
        </ListItem>

        <ProgressBarSpacer />
      </>
    );
  }

  return null;
}

function ProgressBarSpacer() {
  return (
    <Spacer py={3} borderLeft={"2px"} borderColor={"greyscale.400"} _last={{ display: "none" }} />
  );
}
